import { render, staticRenderFns } from "./CopyTxid.vue?vue&type=template&id=06baac54&"
import script from "./CopyTxid.vue?vue&type=script&lang=js&"
export * from "./CopyTxid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports